import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

@Injectable()
export class FaqService {
  baseHref = environment.dashboardBaseRef;

  constructor(private http: HttpClient) {}

  fetchMainFaqCats(): Observable<any> {
    const url = `${this.baseHref}api/faqs/mainCats`;
    return this.http.get<any>(url);
  }

  fetchFaqMainCatsByReferer(referer: string): Observable<any> {
    const url = `${this.baseHref}api/faqs/${referer}`;
    return this.http.get<any>(url);
  }

  searchFaq(keywords: string): Observable<any> {
    let country: string | null = localStorage.getItem(
      'ngx-webstorage|pinploy_lang',
    );
    country = JSON.parse(country).flag;
    if (country === 'dk') {
      country = 'DK';
    } else {
      country = 'ENG';
    }
    const url = `${this.baseHref}api/faqs/search?keywords=${keywords}&lang=${country}`;
    return this.http.get<any>(url);
  }

  postFaqReview(slug: string, wasUseful: boolean): Observable<any> {
    const review = {
      slug,
      wasUseful,
    };
    const url = `${this.baseHref}api/faq-review`;
    return this.http.post<any>(url, review);
  }

  fetchFaqBySlug(
    slug: string,
    countryCode: string | undefined,
  ): Observable<any> {
    let url;
    if (countryCode) {
      url = `${this.baseHref}api/faqs/${countryCode}/${slug}/active`;
    } else {
      url = `${this.baseHref}api/faqs/${slug}/active`;
    }
    return this.http.get<any>(url);
  }

  fetchFaqTitles(
    countryCode: string,
    cat: string,
    refeer?: string,
  ): Observable<any> {
    const url = `${this.baseHref}api/faqs/titles/${countryCode}/${cat}/${refeer}`;
    return this.http.get<any>(url);
  }

  fetchFaqsByCat(
    cat: string,
    countryCode: string,
    referrer: string,
  ): Observable<any> {
    const url = `${this.baseHref}api/faqs/by-cat/${cat}?countryCode=${countryCode}&referrer=${referrer}`;
    return this.http.get<any>(url);
  }
}
